import * as React from 'react'

import { Team, League } from '../../../sdk/model';
import { teamApi } from '../../../adapters/APIExporter';
import ManageUserGroup from '../../util/ManageUserGroup';

interface editOwnersProps {
  team: Team,
  league: League,
  callback: Function
}

function EditOwners(props: editOwnersProps) {
  function submitChanges(updatedOwners) {
    const newTeam = {...props.team};
    newTeam.owners = updatedOwners;
    teamApi.updateTeam(props.team.id!, newTeam).then(props.callback);
  }
  
  return <ManageUserGroup title="Owner(s)" initialUsers={props.team.owners!} omittedUsers={props.league.teams.flatMap(team => team.owners!)} submitChanges={submitChanges} autosubmit={false} />
}

export default EditOwners;
